import ApplicationController from '../application_controller'
import { put, patch } from '@rails/request.js'

class CheckboxController extends ApplicationController {
  switch (event) {
    const element = event.currentTarget

    patch(`appointment_types/${element.dataset.id}`, {
      responseKind: 'json',
      body: {
        appointment_type: {
          [element.name]: element.checked
        }
      }
    })
  }

  activity (event) {
    const element = event.currentTarget

    put(`appointment_types/${element.dataset.id}/switch_activity`, {
      body: {
        enabled: element.checked
      }
    })
  }
}

export default CheckboxController
